/* eslint-disable id-length */
export const MAP_ZOOM_CORRECTION = 0.6;

export default class Melown3dPos {
	_keys: Array<string>;

	_data: Array<any>;

	/**
	 * Vlastni objekt pro pozici v melown 3d - jejich reseni je zbytecne slozite.
	 *
	 * @param  {Array|Object} data Vstupni data, ze kterych by se mela pozice naplnit
	 */
	constructor(data) {
		this._keys = ["viewMode", "x", "y", "heightMode", "zOther", "yaw", "pitch", "roll", "z", "fov"];
		this._data = [
			"obj", 0, 0, "float", 0, 0, 0, 0, 400, 90,
		];

		this.setData(data);
	}

	set viewMode(value) {
		this._data[0] = value;
	}

	get viewMode() {
		return this._data[0];
	}

	set x(value) {
		this._data[1] = value % 360;
	}

	get x() {
		return this._data[1];
	}

	set y(value) {
		this._data[2] = Math.max(Math.min(value, 90), -90);
	}

	get y() {
		return this._data[2];
	}

	set heightMode(value) {
		this._data[3] = value;
	}

	get heightMode() {
		return this._data[3];
	}

	set zOther(value) {
		this._data[4] = value;
	}

	get zOther() {
		return this._data[4];
	}

	set yaw(value) {
		this._data[5] = value;
	}

	get yaw() {
		return this._data[5];
	}

	set pitch(value) {
		this._data[6] = value;
	}

	get pitch() {
		return this._data[6];
	}

	set roll(value) {
		this._data[7] = value;
	}

	get roll() {
		return this._data[7];
	}

	set z(value) {
		this._data[8] = value;
	}

	get z() {
		return this._data[8];
	}

	set fov(value) {
		this._data[9] = value;
	}

	get fov() {
		return this._data[9];
	}

	/**
	 * Nastaveni zoomu z mercatoru do pozice.
	 *
	 * @param  {Number} zoom Mercator zoom
	 */
	set mercZ(zoom) {
		if (typeof zoom !== "number") {
			return;
		}

		const resolution = 156543.034/ Math.pow(2, zoom); // m/px
		const halfHeight = window.innerHeight / 2;
		const y = Math.floor(resolution * halfHeight);

		// potrebujeme pulku - je to ve stupnich - proto / 2 * / 180 na radiany [rad]; vertikalni fov - proto vyska
		const alfa = this.fov / 360 * Math.PI;

		this.z = Math.floor(y / Math.tan(alfa));
	}

	/**
	 * Ziskani zoomu v mercatoru z aktualnich dat.
	 *
	 * @return  {Number}
	 */
	get mercZ() {
		return Math.round(this.mercZraw);
	}

	/**
	 * Ziskani zoomu v mercatoru z aktualnich dat - tohle vraci float cislo, pro dalsi pouziti.
	 *
	 * @return  {Number}
	 */
	get mercZraw() {
		const alfa = this.fov / 360 * Math.PI;
		const y = Math.tan(alfa) * this.z;
		// z / pulka size.y; pocet metru na pixel
		const mPPx = 2 * y / window.innerHeight;

		return Math.log(156543.034 / mPPx) / Math.log(2);
	}

	/**
	 * Ziskani vysky v mercatoru pro pouziti na mape.
	 *
	 * @return {Number}
	 */
	get mercZmap() {
		return Math.round(this.mercZraw - MAP_ZOOM_CORRECTION);
	}

	/**
	 * Prevod na pole, ktere zere prohlizecka 3d.
	 *
	 * @return {Array}
	 */
	toArray() {
		return this._data;
	}

	/**
	 * Nastavit data pozici.
	 *
	 * @param {Array|Object} data Vlastni pole; objekt s parametry pro update pozice
	 */
	setData(data) {
		if (!data || typeof data !== "object") {
			return this;
		}

		if (Array.isArray(data) && data.length === 10) {
			this._data = data;
			// pro spravne hodnoty
			// eslint-disable-next-line no-self-assign
			this.x = this.x;
			// eslint-disable-next-line no-self-assign
			this.y = this.y;
		} else {
			this._keys.forEach(key => {
				if (key in data) {
					this[key] = data[key];
				}
			});

			if ("mercZ" in data) {
				this.mercZ = data.mercZ;
			}
		}

		return this;
	}
}
